import Badge from '../components/Badge'
import BaseAlert from '../components/BaseAlert'
import BaseButton from '../components/BaseButton'
import BaseCheckbox from '../components/BaseCheckbox'
import BaseInput from '../components/BaseInput'
import BasePagination from '../components/BasePagination'
import BaseProgress from '../components/BaseProgress'
import BaseRadio from '../components/BaseRadio'
import BaseSlider from '../components/BaseSlider'
import BaseSwitch from '../components/BaseSwitch'
import Card from '../components/Card'
import Modal from '../components/Modal'
import Icon from '../components/Icon'
import TextIcon from '../components/TextIcon'
import BaseDropdown from '../components/BaseDropdown'
import BubblesBackground from '../components/BubblesBackground'

// custom components
import DateRangePicker from '../components/DateRangePicker'
import LanguageSelect from '../components/LanguageSelect'
import CollectionsSelect from '../components/CollectionsSelect'
import PTwistLoading from '../components/PTwistLoading'
import CardHeader from '../components/CardHeader'
import RepositoriesMasonry from '../components/RepositoriesMasonry'
import InfluencersMasonry from '../components/InfluencersMasonry'
import TopPostsMasonry from '../components/TopPostsMasonry'
import TopUrlsMasonry from '../components/TopUrlsMasonry'
import WordcloudsTopPostsMasonry from '../components/WordcloudsTopPostsMasonry'
import NoDataError from '../components/NoDataError'
import ServerError from '../components/ServerError'

import Map from '../components/Map'
import VueWordCloud from 'vuewordcloud'

export default {
  install (Vue) {
    Vue.component(BaseDropdown.name, BaseDropdown)
    Vue.component(Badge.name, Badge)
    Vue.component(BaseAlert.name, BaseAlert)
    Vue.component(BaseButton.name, BaseButton)
    Vue.component(BaseInput.name, BaseInput)
    Vue.component(BaseCheckbox.name, BaseCheckbox)
    Vue.component(BasePagination.name, BasePagination)
    Vue.component(BaseProgress.name, BaseProgress)
    Vue.component(BaseRadio.name, BaseRadio)
    Vue.component(BaseSlider.name, BaseSlider)
    Vue.component(BaseSwitch.name, BaseSwitch)
    Vue.component(Card.name, Card)
    Vue.component(Icon.name, Icon)
    Vue.component(TextIcon.name, TextIcon)
    Vue.component(Modal.name, Modal)
    // custom components
    Vue.component(LanguageSelect.name, LanguageSelect)
    Vue.component(CollectionsSelect.name, CollectionsSelect)
    Vue.component(DateRangePicker.name, DateRangePicker)
    Vue.component(Map.name, Map)
    Vue.component(PTwistLoading.name, PTwistLoading)
    Vue.component(ServerError.name, ServerError)
    Vue.component(NoDataError.name, NoDataError)
    Vue.component(BubblesBackground.name, BubblesBackground)
    Vue.component(CardHeader.name, CardHeader)
    Vue.component(VueWordCloud.name, VueWordCloud)
    Vue.component(RepositoriesMasonry.name, RepositoriesMasonry)
    Vue.component(InfluencersMasonry.name, InfluencersMasonry)
    Vue.component(TopPostsMasonry.name, TopPostsMasonry)
    Vue.component(TopUrlsMasonry.name, TopUrlsMasonry)
    Vue.component(WordcloudsTopPostsMasonry.name, WordcloudsTopPostsMasonry)
  }
}
